import { MIS_ROLE_RATIO_REPORT } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';
import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../resources/serviceURLs';

export const getRoleRatioReportBaseURL = () => {
  const serviceURL = appendServiceNameToURL(serviceName.PROJECT_MS);
  const servicePort = appendServicePortToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}/api${MIS_ROLE_RATIO_REPORT}`;
  }

  return `${baseUrl}:${servicePort}${serviceURL}/api${MIS_ROLE_RATIO_REPORT}`;
};

const ROLE_RATIO_FILTER_TYPE_BY_FIELD = {
  employeeVertical: 'employee-verticals',
  projectVertical: 'project-verticals',
  projectType: 'project-types',
  projectStatus: 'project-statuses',
  clientId: 'clients',
  projectId: 'projects',
  projectManager: 'project-managers',
};

export const ROLE_RATIO_FILTER_TYPES = {
  projectTypes: ROLE_RATIO_FILTER_TYPE_BY_FIELD.projectType,
};

export const getRoleRatioFilterOptionUrl = (field = '') => {
  const filterType = ROLE_RATIO_FILTER_TYPE_BY_FIELD[field];
  return filterType ? `${getRoleRatioReportBaseURL()}/filter-options/${filterType}` : '';
};

export const getRoleRatioFilterOptions = (filterType = '', userInfo = {}) => ({
  url: `${MIS_ROLE_RATIO_REPORT}/filter-options/${filterType}`,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload: { payload: { searchQuery: '', userInfo } },
  service: serviceName.PROJECT_MS,
});

export const getConfigureRole = (roleId = '', userInfo = null) => {
  const queryParams = new URLSearchParams();
  if (roleId) queryParams.set('roleId', roleId);
  if (userInfo) queryParams.set('userInfo', JSON.stringify(userInfo));
  const queryString = queryParams.toString();

  return {
    url: `${MIS_ROLE_RATIO_REPORT}/configure-role${queryString ? `?${queryString}` : ''}`,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PROJECT_MS,
  };
};

export const getRoleRatioFilters = ({ lightweight = false, userInfo = null } = {}) => {
  const queryParams = new URLSearchParams();
  if (lightweight) queryParams.set('lightweight', '1');
  if (userInfo && !lightweight) queryParams.set('userInfo', JSON.stringify(userInfo));
  const queryString = queryParams.toString();

  return {
    url: `${MIS_ROLE_RATIO_REPORT}/filters${queryString ? `?${queryString}` : ''}`,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PROJECT_MS,
  };
};

export const exportRoleRatioReport = (payload) => ({
  url: `${MIS_ROLE_RATIO_REPORT}/export`,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload,
  service: serviceName.PROJECT_MS,
});

export const saveConfigureRole = (payload, userInfo = null) => ({
  url: `${MIS_ROLE_RATIO_REPORT}/configure-role`,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload: userInfo ? { ...payload, userInfo } : payload,
  service: serviceName.PROJECT_MS,
});

export const deleteConfigureRole = (roleId, userInfo = null) => {
  const queryParams = new URLSearchParams();
  if (userInfo) queryParams.set('userInfo', JSON.stringify(userInfo));
  const queryString = queryParams.toString();

  return {
    url: `${MIS_ROLE_RATIO_REPORT}/configure-role/${roleId}${queryString ? `?${queryString}` : ''}`,
    method: 'delete',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PROJECT_MS,
  };
};
